module.exports = __webpack_public_path__ + "img/oil-processing.1e94d211.png";